const DoneRedIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.23779" r="8" fill="#F23D4F" />
    <path
      d="M4.5 8.73779L7 11.2378L12 5.73779"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DoneRedIcon;
